module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-flex"
  }, [(!this.$store.state.posts) ? _c('div', {
    staticClass: "u-align-center"
  }, [_c('icon', {
    staticClass: "c-icon-loading",
    attrs: {
      "use": "loading"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$store.state.posts) ? _c('div', [(this.type === 'list') ? _c('div', _vm._l((this.$store.state.posts), function(post) {
    return _c('post', {
      key: post.slug,
      attrs: {
        "title": post.title.rendered,
        "author": _vm.getUserName(post.author),
        "date": _vm.formatDate(post.date),
        "preview": post.excerpt.rendered,
        "slug": post.slug,
        "previewImage": post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url
      }
    })
  })) : _vm._e(), _vm._v(" "), (this.type === 'single') ? _c('div', [(_vm.singlePost) ? _c('post', {
    attrs: {
      "title": _vm.singlePost.title.rendered,
      "author": _vm.getUserName(_vm.singlePost.author),
      "date": _vm.formatDate(_vm.singlePost.date),
      "content": _vm.singlePost.content.rendered,
      "slug": _vm.singlePost.slug,
      "fullImage": _vm.singlePost._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa5f490e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/posts/posts.vue
// module id = 146
// module chunks = 1